module.exports = __webpack_public_path__ + "img/bowl.b8b74aab.jpg";